module.exports = __webpack_public_path__ + "img/sc.bc08a6b5.svg";